import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromSport from '../reducers/sport.reducer';
export const selectSportState = createFeatureSelector<fromSport.State>('sport');
export const selectSports = createSelector(
  selectSportState,
  (state: fromSport.State) => state.sports
);

export const selectSportErrorMessage = createSelector(
  selectSportState,
  (state: fromSport.State) => state.errorMessage
);

export const selectIsSportLoading = createSelector(
  selectSportState,
  (state: fromSport.State) => state.isLoading
);